var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleUssersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0013 6.22656C11.2664 6.22656 10.5617 6.51849 10.042 7.03812C9.5224 7.55775 9.23047 8.26253 9.23047 8.9974C9.23047 9.73227 9.5224 10.437 10.042 10.9567C10.5617 11.4763 11.2664 11.7682 12.0013 11.7682C12.7362 11.7682 13.4409 11.4763 13.9606 10.9567C14.4802 10.437 14.7721 9.73227 14.7721 8.9974C14.7721 8.26253 14.4802 7.55775 13.9606 7.03812C13.4409 6.51849 12.7362 6.22656 12.0013 6.22656ZM10.1055 8.9974C10.1055 8.49459 10.3052 8.01238 10.6607 7.65684C11.0163 7.3013 11.4985 7.10156 12.0013 7.10156C12.5041 7.10156 12.9863 7.3013 13.3419 7.65684C13.6974 8.01238 13.8971 8.49459 13.8971 8.9974C13.8971 9.5002 13.6974 9.98241 13.3419 10.338C12.9863 10.6935 12.5041 10.8932 12.0013 10.8932C11.4985 10.8932 11.0163 10.6935 10.6607 10.338C10.3052 9.98241 10.1055 9.5002 10.1055 8.9974ZM12.0013 12.6432C10.8113 12.6432 9.71347 12.9174 8.8968 13.3841C8.09297 13.8437 7.48047 14.5449 7.48047 15.4141C7.48047 16.2832 8.09297 16.9844 8.8968 17.4441C9.71347 17.9107 10.8119 18.1849 12.0013 18.1849C13.1907 18.1849 14.2891 17.9107 15.1058 17.4441C15.9096 16.9844 16.5221 16.2832 16.5221 15.4141C16.5221 14.5449 15.9096 13.8437 15.1058 13.3841C14.2891 12.9174 13.1907 12.6432 12.0013 12.6432ZM8.35547 15.4141C8.35547 14.9941 8.65705 14.5291 9.3308 14.1441C9.9923 13.7661 10.9356 13.5182 12.0013 13.5182C13.0671 13.5182 14.0103 13.7661 14.6718 14.1441C15.3456 14.5291 15.6471 14.9946 15.6471 15.4141C15.6471 15.8335 15.3456 16.299 14.6718 16.684C14.0103 17.062 13.0671 17.3099 12.0013 17.3099C10.9356 17.3099 9.9923 17.062 9.3308 16.684C8.65705 16.299 8.35547 15.8341 8.35547 15.4141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUssersIcon);
export default __webpack_public_path__ + "static/media/SingleUssersIcon.2c6eec421a390ec5ae459f72b28ec2f2.svg";
export { ForwardRef as ReactComponent };